import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import {Ripple} from 'vuetify/lib/directives';
import VuetifyConfirm from 'vuetify-confirm';
import 'vuetify/src/stylus/app.styl';

Vue.use(Vuetify, {
  iconfont: 'md',
  directives: {
    Ripple
  }
});

Vue.use(VuetifyConfirm);
